<template>
  <div class="input-group" style="margin-bottom: 5px;">
    <span class="input-group-addon">〒</span>
    <input type="tel" :placeholder="placeholder" class="form-control"
           ref="input" @input="formatted_call_to_number" @focus="formatted_call_to_number" v-model="zip">
  </div>
</template>

<script>
  export default {
    name: 'ZipInput',
    props: {
      value: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '000-0000'
      },
      onlyNumber: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        value_old: ''
      };
    },
    mounted: function () {
      this.$nextTick(() => {
        this.$emit('input', this.$options.filters.decodeZip(this.value));
      });
    },
    computed: {
      zip: {
        get () {
          return this.$options.filters.decodeZip(this.value);
        },
        set (value) {
          this.$emit('input', this.$options.filters.decodeZip(value));
        }
      }
    },
    methods: {
      formatted_call_to_number (event) {
        if (event.target.value === '') return;
        if (event.target.value === this.value_old) return;
        if (event.inputType === 'deleteContentBackward') {
          if (this.value_old[this.value_old.length - 1] === '-') {
            this.$emit('input', event.target.value.slice(0, event.target.value.length - 1));
          }
        } else if (event.inputType === 'insertCompositionText') {
        } else {
          let value = event.target.value;
          value = this.removeNotNumber(value);
          this.value_old = value;
          this.$emit('input', this.$options.filters.decodeInternationalPhoneNumber(value));
        }
      },
      removeNotNumber (value) {
        if (!this.onlyNumber) return value;
        if (!value) return value;
        value = value.replace(/[^0-9０-９ー-]/g, '');
        this.$refs.input.value = value;
        return value;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .input-group {
    .input-group-addon {
      padding: 6px 10px;
      font-size: 14px;
      font-weight: normal;
      line-height: 1;
      color: #555;
      background-color: #e0e3e0;
      text-align: center;
      border: 1px solid #ccc;
      height: 35px;
      display: inline-block;
      vertical-align: bottom;
      padding: 10px 6px;
      box-sizing: border-box;

      &:first-child {
        border-right: 0;
      }
    }
  }
</style>
